import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate, faFileCircleCheck } from "@fortawesome/free-solid-svg-icons";

export const renderFilterCellDocsAdm = (col, idx, context) => {
  switch (col.admFilterType) {
    case "Admin actions": {
      const { colorFilterAction, page, t, handleRelaunchClickInstance, openConfirmAutoRelaunch } = context;
      
      if (page !== "DocStatus") {
        return (
          
          <th key={`actions-${idx}`} style={{ backgroundColor: colorFilterAction }} >
            <button
              className="btn bg-light text-hover-blue"
              title={t("Relaunch docs instance status")}
              onClick={handleRelaunchClickInstance}
              style={{ marginRight : '10px'}}
            >
              <FontAwesomeIcon icon={faRotate} className="fa-copy" />
            </button>
            
            <button
              className="btn bg-light text-hover-blue"
              title={t("Auto relaunch (filtered documents)")}
              onClick={openConfirmAutoRelaunch}
            >
              <FontAwesomeIcon icon={faFileCircleCheck} />
            </button>
          </th>
         
        );
      } else {
        return (
          <th style={{backgroundColor: colorFilterAction}}>
            <button
              className="btn bg-light text-hover-blue"
              title={t("Auto relaunch (filtered documents)")}
              onClick={openConfirmAutoRelaunch}
            >
              <FontAwesomeIcon icon={faFileCircleCheck} />
            </button>
          </th>
        )
      }
    }
    default:
      return (
        <th
          key={`filter-default-${idx}`}
          className="style_tbody_th"
          style={{ backgroundColor: context.colorFilterAction }}
        ></th>
      );
  }
};
